import { render, staticRenderFns } from "./OrderConfirmationStage.vue?vue&type=template&id=538d322e&"
import script from "./OrderConfirmationStage.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmationStage.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirmationStage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports